import { Tour } from '@/types/tourBooking';
import { NextRouter } from 'next/router';

const devHosts = ['localhost', 'k2ktech'];

// prettier-ignore
const emailPattern = /^[a-zA-Z0-9\.\_\%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$/; //g -> remove global flag

// Dữ liệu polyline
const polylineCoords = [
  { lat: 15.9209039, lng: 108.3248058 },
  { lat: 15.9106931, lng: 108.2997749 },
  { lat: 15.8997146, lng: 108.2938526 },
  { lat: 15.8881577, lng: 108.2885311 },
  { lat: 15.8763413, lng: 108.2991505 },
  { lat: 15.8745862, lng: 108.3173569 },
  { lat: 15.8663303, lng: 108.3337506 },
  { lat: 15.8684768, lng: 108.3457669 },
  { lat: 15.8650093, lng: 108.3499726 },
  { lat: 15.863647, lng: 108.3590062 },
  { lat: 15.8677338, lng: 108.3611306 },
  { lat: 15.8700455, lng: 108.3738335 },
  { lat: 15.8732247, lng: 108.3916092 },
  { lat: 15.8759896, lng: 108.3936604 },
  { lat: 15.8830068, lng: 108.390313 },
  { lat: 15.9236914, lng: 108.3272811 },
  { lat: 15.9209039, lng: 108.3248058 },
];

const regexNumber = /^[0-9]+$/g;
const regexPhone = /^\+?[0-9]+$/g;
const regexSlug = /^[a-zA-Z0-9-]+$/g;

const formatDateRequest = 'YYYY-MM-DD';
const formatDateDisplay = 'DD/MM/YYYY';
const formatTimeDisplay = 'HH:mm';

const getMinPriceOfTour = (tour: Tour) =>
  tour.tourPriceOptions.reduce(
    (min, option) => Math.min(min, option.tourPricing?.defaultPrice ?? 0),
    tour.tourPriceOptions[0].tourPricing?.defaultPrice ?? 0,
  );

const contactNumberTypeOptionsList = [
  { label: 'common:phone', value: 'phone' },
  { label: 'Zalo', value: 'zalo' },
  { label: 'Whatsapp', value: 'whatsapp' },
  { label: 'Kakaotalk', value: 'kakaotalk' },
  { label: 'Viber', value: 'viber' },
];

const getThumbnailForPartner = (tour: Tour) => {
  if (tour.images?.length > 0 && tour.images[0] !== '') {
    return tour.images[0];
  }
  return '/assets/images/ic_app_logo.png';
};

const getThumbnailImage = (tour: Tour) => {
  if (tour.thumbnailImage && tour.thumbnailImage !== '') {
    return tour.thumbnailImage;
  }

  if (tour.imageDetails?.[0] && tour.imageDetails[0].url && tour.imageDetails[0].url !== '') {
    return tour.imageDetails[0].url;
  }
  return '/assets/images/ic_app_logo.png';
};

const getThumbnailImageAlt = (tour: Tour) => {
  if (tour.imageDetails?.[0] && tour.imageDetails[0].alt !== '') {
    return tour.imageDetails[0].alt;
  }
  return null;
};

const convertImages = (data: any): Tour[] => {
  return data.map((item: any) => ({
    ...item,
    images: JSON.parse(item.images) as string[], // Convert images to array
  }));
};

const pushToBookingDetail = (router: NextRouter, codeTracking: string) => {
  const newQuery = _getNewQuery(router);

  router.push({
    pathname: '/booking/[code]',
    query: {
      ...newQuery,
      code: codeTracking,
    },
  });
};

const pushToPublicHistory = (router: NextRouter, tel: string) => {
  const newQuery = _getNewQuery(router);

  router.push({
    pathname: '/public-history/[tel]',
    query: {
      ...newQuery,
      tel: tel,
    },
  });
};

const _getNewQuery = (router: NextRouter) => {
  const currentQuery = router.query;
  return Object.fromEntries(
    Object.entries(currentQuery).filter(
      ([key]) => key !== 'tab' && key !== 'tourType' && key !== 'slug',
    ),
  );
};

const queryToDetailTourUrl = (
  tourType: string,
  slug: string,
  router: NextRouter,
) => {
  return `/${router.locale ?? 'en'}/${tourType}/${slug}${
    router.asPath.includes('?')
      ? '?' +
        Object.entries(router.query)
          .filter(([key]) => key !== 'tab')
          .map(([key, value]) => `${key}=${value}`)
          .join('&')
      : ''
  }`;
};

const queryToHomeUrl = (rootPage: string, router: NextRouter) => {
  return `/${rootPage}${
    router.asPath.includes('?')
      ? '?' +
        Object.entries(router.query)
          .filter(([key]) => key !== 'tab')
          .map(([key, value]) => `${key}=${value}`)
          .join('&')
      : ''
  }`;
};

const getImageUrl = (assetId: string) => `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${assetId}`
export {
  devHosts,
  emailPattern,
  polylineCoords,
  regexNumber,
  regexPhone,
  regexSlug,
  formatDateDisplay,
  formatTimeDisplay,
  formatDateRequest,
  getMinPriceOfTour,
  contactNumberTypeOptionsList,
  getThumbnailForPartner,
  getThumbnailImage,
  getThumbnailImageAlt,
  convertImages,
  pushToBookingDetail,
  pushToPublicHistory,
  queryToDetailTourUrl,
  queryToHomeUrl,
  getImageUrl,
};
